module.exports = __webpack_public_path__ + "img/img22.a56bc57c.svg";